import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import styled from 'styled-components';
import Breakpoints from 'themes/constants/breakpoints';
import { ServiceQuery } from 'generated/graphql';
import { PATH_PREFIX, TEXT_FOOTER, TEXT_FOOTER_UNDER } from 'routes/routes';
import logoFooter from 'assets/Icons/logo_footer.svg';
import FooterMenu from './FooterMenu';

const FooterWrapper = styled.div`
    width: 100%;
    min-height: 145px;
    background-color: #2d2d2d;
    border-radius: 10px 10px 0 0;
    padding: 10px 20px 20px;
    margin: 0 auto;
    box-sizing: border-box;
    z-index: 1;
    a {
        color: inherit;
        :active, :visited, :hover {
            color: inherit;
        }
    }
    @media only screen and (${Breakpoints.TABLET}) {
        padding: 25px;
    }
`;

const FooterInner = styled.div`
    max-width: ${({ theme }) => theme.maxWidth};
    width: 100%;
    height: 100%;
    font-size: 14px;
    color: #e4e4e4;
    text-align: justify;
    margin: 0 auto;
    a {
        color: inherit;
        :active, :visited, :hover {
            color: inherit;
        }
    }
    @media only screen and (${Breakpoints.LAPTOP}) {
        display: flex;
        flex-direction: row;
    }
`;

const Contacts = styled.div`
    font-size: 12px;
    margin: 10px 0;
    p {
        margin: 0;
    }
    @media only screen and (${Breakpoints.TABLET}) {
        margin: 25px 0;
    }
`;

const Info = styled.div`
    margin-bottom: 20px;
`;

const OfferLink = styled(Link)`
    display: block;
`;

const LogoWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media only screen and (${Breakpoints.TABLET}) {
        justify-content: center;
    }
    @media only screen and (${Breakpoints.LAPTOP}) {
        justify-content: flex-start;
    }
`;

const Logo = styled.img`
    margin-right: 20px;
    @media only screen and (${Breakpoints.LAPTOP}) {
        margin-right: 12px;
    }
`;

const Year = styled.span`
    color: #7A7A7A;
`;

const LeftSide = styled.div`
    @media only screen and (${Breakpoints.LAPTOP}) {
        flex: 1;
        margin-right: 45px;
    }
`;

const RightSide = styled.div`
    @media only screen and (${Breakpoints.LAPTOP}) {
        flex: 1;
    }
`;
const LinksWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    margin-bottom: 20px;
    @media only screen and (${Breakpoints.TABLET}) {
        margin-bottom: 28px;
    }
    @media only screen and (${Breakpoints.LAPTOP}) {
        margin-bottom: 20px;
    }
`;

interface IFooterProps {
  data: ServiceQuery | undefined
}

const Footer = ({ data }: IFooterProps) => {
  const [state, setState] = useState({
    top: '',
    bottom: '',
  });
  useEffect(() => {
    axios.get(`${PATH_PREFIX}${TEXT_FOOTER}`)
      .then((res) => {
        if (res.data) {
          setState((st) => ({ ...st, top: res.data }));
        }
      })
      .catch(() => {});
    axios.get(`${PATH_PREFIX}${TEXT_FOOTER_UNDER}`)
      .then((res) => {
        if (res.data) {
          setState((st) => ({ ...st, bottom: res.data }));
        }
      })
      .catch(() => {});
  }, []);

  return (
    <FooterWrapper>
      <FooterInner>
        <LeftSide>
          <LinksWrapper>
            <OfferLink to={`${PATH_PREFIX}/user/conditions`}>
              Правила использования
            </OfferLink>
            <OfferLink to={`${PATH_PREFIX}/privacypolicy`}>
              Политика обработки персональных данных
            </OfferLink>
          </LinksWrapper>
          <Info dangerouslySetInnerHTML={{ __html: state.top }} />
        </LeftSide>
        <RightSide>
          {data?.point?.service.categories && <FooterMenu categories={data?.point?.service.categories} />}
          <Contacts dangerouslySetInnerHTML={{ __html: state.bottom }} />
          <LogoWrapper>
            <Logo src={logoFooter} alt="" />
            <Year>
              ® 2024
            </Year>
          </LogoWrapper>
        </RightSide>
      </FooterInner>
    </FooterWrapper>
  );
};

export default Footer;
